import type { TrigKey } from './keys';

export const ko: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': '수학 · 삼각법',
  'panel.experiment': '실험',
  'panel.params': '매개변수',
  'panel.scene': '실험 선택',
  'experiment.right-triangle.label': '직각삼각형',
  'experiment.unit-circle.label': '단위원',
  'experiment.wave-studio.label': '파동 스튜디오',
  'experiment.identity-playground.label': '항등식',
  'experiment.triangle-solver.label': '삼각형 해석',
  'experiment.circular-polar.label': '원·극좌표',
  'hint.line1': '점을 끌고 슬라이더를 움직이세요.',
  'hint.line2': '교육은 기하에 있고 글에 있지 않습니다.',
  'rt.angle.a': '각 A',
  'rt.angle.b': '각 B',
  'rt.angle.value': '∠',
  'rt.units.rad': '라디안',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tan',
  'rt.snap': '30°/45°/60° 스냅',
  'uc.units': '단위',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tan',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'cot',
  'uc.show.astc': 'ASTC 표시',
  'uc.snap.common': '주요 각에 스냅',
  'uc.angle.value': '∠',
  'uc.units.deg': '도',
  'uc.units.rad': 'rad',
  'uc.units.both': '도+rad',
  'ws.fn': '함수',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tan',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'cot',
  'ws.amplitude': 'A — 진폭',
  'ws.frequency': 'B — 주파수',
  'ws.phase': 'C — 위상 이동',
  'ws.shift': 'D — 세로 이동',
  'ws.rform.toggle': 'R-형식 유도',
  'ws.rform.a': 'a (sin 계수)',
  'ws.rform.b': 'b (cos 계수)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': '초기화',
  'ws.base': '기본 곡선 표시',
  'ip.id.pythagorean': '피타고라스',
  'ip.id.reciprocal': '역수',
  'ip.id.quotient': '몫',
  'ip.id.sum': '합',
  'ip.id.difference': '차',
  'ip.id.double': '배각',
  'ip.id.half': '반각',
  'ip.play': '재생',
  'ip.pause': '일시정지',
  'ip.step': '한 걸음',
  'ip.reset': '초기화',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  cot θ = 1/tan θ',
  'ip.proof.quotient.summary': 'tan θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': 'v2에서 — 이 증명은 더 정교한 구성이 필요합니다.',
  'ts.area': '넓이',
  'ts.sineRule': '사인 법칙',
  'ts.cosineRule': '코사인 법칙',
  'ts.ambiguous.toggle': '모호할 때 유령 삼각형',
  'ts.reset': '정삼각형으로 초기화',
  'ts.snap.integers': '정수 스냅',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': '변',
  'ts.section.angles': '각',
  'ts.section.sineRule': '사인 법칙',
  'ts.section.cosineRule': '코사인 법칙',
  'ts.section.area': '넓이',
  'cp.omega': '각속도',
  'cp.plot.y': 'y 그리기 (sin)',
  'cp.plot.x': 'x 그리기 (cos)',
  'cp.polar.label': '극좌표 도형',
  'cp.polar.circle': '원 (r = 1)',
  'cp.polar.rose': '장미 (r = sin 3θ)',
  'cp.polar.cardioid': '심장곡선 (r = 1 + cos θ)',
  'cp.polar.limacon': '리마송 (r = 1 − 2 cos θ)',
  'cp.smallAngle': '미소각 근사 (sin x ≈ x)',
  'cp.play': '재생',
  'cp.pause': '일시정지',
  'cp.reset': '초기화',
  'cp.step': '걸음 π/12',
};
